module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-d347161dc556fde267b7f97d2ac018d9.jpg";